import { memo } from 'react'

const CustomerHelpDeskWrapper = () => {
  return null
}

export default memo(CustomerHelpDeskWrapper)
